import React from "react";
import Image from "next/image";
import {
  Container,
  ImageWrap,
  TitleText,
  ContentWrap,
  SummaryContent,
  Highlight,
  ImageContainer,
} from "./styled";

const SummarySection = () => {
  return (
    <Container>
      <ImageContainer>
        <ImageWrap>
          <Image
            alt="line-drawn kitchen icon"
            src="/images/home_page/property_service_icon.png"
            layout="fill"
            loading="lazy"
            quality={70}
          />
        </ImageWrap>
      </ImageContainer>
      <TitleText>Making your dreams a reality.</TitleText>
      <ContentWrap>
        <SummaryContent>
          We’ve been providing our customers with high quality, custom closets,
          and <Highlight>Kitchen and Bath solutions</Highlight> for over 35
          years. Read what some of our clients have said about their “Classy Experience”.
        </SummaryContent>
      </ContentWrap>
    </Container>
  );
};

export default SummarySection;
